module.exports = __webpack_public_path__ + "img/20.65ed8331.jpg";